const { ENV, STAGE, VERSION, DATADOG_CONFIG, API_HOST, KEYCLOAK_HOST } = window.__ENVIRONMENT__
export { ENV, STAGE, VERSION, DATADOG_CONFIG, API_HOST, KEYCLOAK_HOST }
